export default __webpack_public_path__ + "locales/hy-AM/MainBar.json?hash=a9d4f747a03d8c2db049c71fb0b9212a";